import { Badge } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const INTERACTION_STATUS_STYLES = {
    finished:              { bg: "green.900",  borderColor: "green.700",  color: "green.300" },
    inprogress:            { bg: "blue.900",   borderColor: "blue.700",   color: "blue.300" },
    holded:                { bg: "yellow.900", borderColor: "yellow.700", color: "yellow.300" },
    cancelled:             { bg: "red.900",    borderColor: "red.700",    color: "red.300" },
    qualifiedfornextstage: { bg: "purple.900", borderColor: "purple.700", color: "purple.300" },
    furtherselection:      { bg: "cyan.900",   borderColor: "cyan.700",   color: "cyan.300" },
    readytohire:           { bg: "teal.900",   borderColor: "teal.700",   color: "teal.300" },
    hired:                 { bg: "green.900",  borderColor: "green.700",  color: "green.300" },
    rejected:              { bg: "red.900",    borderColor: "red.700",    color: "red.300" },
    candidateresigned:     { bg: "gray.800",   borderColor: "gray.600",   color: "gray.400" },
};

const InteractionStatusBadge = ({ status }) => {
    const { t } = useTranslation("models");
    const key = status?.toLowerCase() ?? "inprogress";
    const style = INTERACTION_STATUS_STYLES[key] ?? INTERACTION_STATUS_STYLES.inprogress;
    return (
        <Badge
            bg={style.bg}
            borderColor={style.borderColor}
            borderWidth={1}
            variant="subtle"
            fontSize="xs"
            px={3}
            py={0.5}
            borderRadius={6}
            color={style.color}
        >
            {t(`conversationStatus.${key}`)}
        </Badge>
    );
};

export default InteractionStatusBadge;
